/**
 * What an account is using, from the casting backend's meter.
 *
 * Pairs with the stripe service's entitlements, which say what the account is allowed. The
 * two are deliberately separate services: the meter knows nothing about billing, and
 * billing knows nothing about recordings.
 */
import axios from 'axios';
import constants from '../../../constant';
import { withAuthRetry } from '../refresh';

const http = withAuthRetry(
  axios.create({
    baseURL: `${constants.apiCastUrl}/api`,
    timeout: 15000,
  })
);

/**
 * Storage held and AI seconds spent. `periodStart` lets a paid subscription count AI
 * against the window being billed rather than the calendar month.
 */
export function myUsage(options) {
  // The period comes from billing, never from us: a client that chose its own could report
  // itself as having used nothing. `fresh` is for the moment after a plan changes, when the
  // cached answer is the plan the person just stopped being on.
  const params = options && options.fresh ? { fresh: 1 } : {};
  return http.get('/event/usage/me/', { params }).then((r) => r.data);
}
